(function () {
  'use strict';
  const api = window.Naxarly = window.Naxarly || {};
  let selection = null;
  const listeners = [];
  api.ServicePage = {
    select(value) {
      selection = JSON.parse(JSON.stringify(value || {}));
      listeners.forEach((fn) => fn(selection));
      window.dispatchEvent(new CustomEvent('naxarly:service-package-change', { detail: selection }));
    },
    getSelection() { return selection ? JSON.parse(JSON.stringify(selection)) : null; },
    subscribe(fn) { if (typeof fn !== 'function') return () => {}; listeners.push(fn); if (selection) fn(selection); return () => { const i = listeners.indexOf(fn); if (i >= 0) listeners.splice(i, 1); }; }
  };
})();
